module.exports = __webpack_public_path__ + "media/images/new/see_favorites_in_search_laptop-b8c5c02d6a02c9452d7e4bcbaa204974.png";